// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-message-fMtTqH{text-align:left;color:#ff441e}.error-message-fMtTqH .link-mHYoWx{color:#4d53e8}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error-message": `error-message-fMtTqH`,
	"errorMessage": `error-message-fMtTqH`,
	"link": `link-mHYoWx`
};
export default ___CSS_LOADER_EXPORT___;
